<template>
  <v-data-table
    :headers="headers"
    :items="items"
    :search="search"
    :sort-by="['updated_at']"
    :sort-desc="true"
  >
    <template v-slot:top>
      <v-text-field
        v-model="search"
        :label="$t('DATA_TABLE.SEARCH')"
        outlined
        append-icon="mdi-magnify"
      />
    </template>

    <template v-slot:item.updated_at="{ item }">
      {{ item.updated_at | dateFormat }}
    </template>

    <template v-slot:item.status="{ item }">
      <v-chip :color="item.status.color" text-color="white">
        {{ item.status.name }}
      </v-chip>
    </template>

    <template v-slot:item.action="{ item }">
      <div class="text-center">
        <v-list-item @click="$emit('show', item)">
          <v-list-item-title>
            <v-icon class="mr-1" small>mdi-eye</v-icon>
            {{ $t('ITEM.VIEW') }}
          </v-list-item-title>
        </v-list-item>
      </div>
    </template>
  </v-data-table>
</template>

<script>
import { dateFormat } from '@/modules/_global/filters';

export default {
  name: 'TaskReportsList',

  filters: {
    dateFormat
  },

  props: {
    items: {
      type: Array,
      required: true
    }
  },

  data: () => ({
    search: ''
  }),

  computed: {
    headers() {
      return [
        {
          text: this.$t('ITEM.DATE'),
          align: 'left',
          sortable: true,
          value: 'updated_at'
        },
        {
          text: this.$t('EMPLOYEES.ITEM'),
          value: 'employee_full_name'
        },
        {
          text: this.$t('PLANNINGS.NOTES'),
          value: 'notes'
        },
        {
          text: this.$t('ITEM.STATUS'),
          sortable: true,
          value: 'status',
          sort: ({ id: a }, { id: b }) => a - b
        },
        {
          text: this.$t('DATA_TABLE.ACTIONS'),
          value: 'action',
          align: 'center'
        }
      ];
    }
  }
};
</script>
